import client, { callbackClient } from './client';
import { expectedError } from '/src/utils/errors';

const timeoutPromise = (ms) => new Promise((resolve, reject) => setTimeout(() => reject(new Error('timeout')), ms));

// server will return 429 if call send code too frequency
const handleSendCodeLimitError = (error) => {
  if (error.response?.status === 429) {
    return Promise.reject(expectedError('验证码发送过于频繁，请稍后再试'));
  }
  return Promise.reject(error);
};

export const phoneLoginCheck = async ({ phone }) => {
  await client.post('/accounts/api/login/phone/check', { phone });
};

export const sendCode = async (path, { phone, captcha_key, captcha_response } = {}) => {
  await client
    .post(`/accounts/api/${path}/send-code`, { phone, captcha_key, captcha_response })
    .catch(handleSendCodeLimitError);
};

const postLogin = async ({ redirect_to, sso_callbacks }) => {
  await Promise.all([Promise.all(sso_callbacks.map((url) => callbackClient.get(url))), timeoutPromise(500)]).catch(
    () => {}
  );

  return {
    redirectTo: redirect_to,
  };
};

export const phoneLogin = async ({ phone, code, redirect_to }) => {
  const { data: resp } = await client.post('/accounts/api/login/phone', { phone, code, redirect_to });
  return postLogin(resp);
};

export const passwordLogin = async ({ identifier, password, redirect_to }) => {
  const { data: resp } = await client.post('/accounts/api/login/password', { identifier, password, redirect_to });
  return postLogin(resp);
};

export const socialLogin = ({ provider, redirect_to }) => {
  switch (provider) {
    case 'wechat':
      window.open(
        `${client.defaults.baseURL || ''}/accounts/wechat/login?redirect_to=${encodeURIComponent(redirect_to || '')}`,
        '_top'
      )
      break;
    default:
      window.open(
        `${client.defaults.baseURL || ''}/accounts/social/login/${provider}?redirect_to=${encodeURIComponent(redirect_to || '')}`,
        '_top'
      );
      break;
  }
};

export const signup = async ({ company, email, phone, code, redirect_to }) => {
  const { data: resp } = await client.post('/accounts/api/signup', { company, email, phone, code, redirect_to });
  return postLogin(resp);
};

export const forgetSendCode = async ({ identifier }) => {
  await client.post(`/accounts/api/forget/send-code`, { identifier }).catch(handleSendCodeLimitError);
};

export const forgetVerifyCode = async ({ identifier, code }) => {
  return client.post('/accounts/api/forget/verify', { identifier, code });
};

export const forgetResetPassword = async ({ new_password }) => {
  return client.post('/accounts/api/forget/reset-password', { new_password });
};

export const canForgetResetPassword = async () => {
  return client
    .head('/accounts/api/forget/reset-password')
    .then(() => Promise.resolve(true))
    .catch((err) => {
      if (err.response && err.response.status === 428) {
        return Promise.resolve(false);
      } else {
        return Promise.reject(err);
      }
    });
};

export const fetchOrganizationOptions = (word) =>
  client.get('/accounts/api/search-company', { params: { word } }).then((result) =>
    result.data.map(({ name }) => ({
      value: name,
    }))
  );

/**
 * 刷新图片验证码
 * @returns {Promise<{key: string, image_url: string}>} 验证码数据
 */
export const refreshCaptcha = async () => {
  try {
    const resp = await client.post('/accounts/api/captcha/refresh', {});
    // client interceptor returns response.data directly
    // server returns { key, image_url } without data nesting
    return resp || {};
  } catch (error) {
    console.error('刷新验证码失败:', error);
    throw error;
  }
};
